import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';
import { type NewTheme } from '@vakantiesnl/components/src/styles/themes/zoover/newTheme';

import type { AvatarProps } from './Avatar';

const iconSize: Record<Required<AvatarProps>['size'], keyof NewTheme['icon']['size']> = {
	xsmall: 'xSmall',
	small: 'small',
	medium: 'medium',
	large: 'large',
	jumbo: 'xLarge',
};

export const useCustomStyles = makeStyles<Pick<AvatarProps, 'size' | 'circle'>>()(
	(theme, { size = 'medium', circle }) => ({
		container: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			position: 'relative',
			overflow: 'hidden',
			height: theme.avatar.size[size],
			width: theme.avatar.size[size],
			minWidth: theme.avatar.size[size],
			backgroundColor: theme.avatar.background.color,
			borderRadius: theme.avatar.borderRadius[circle ? 'circle' : 'rounded'],
		},
		icon: {
			width: theme.icon.size[iconSize[size]],
			height: theme.icon.size[iconSize[size]],
		},
		imageContainer: {
			position: 'absolute',
			height: '100%',
			width: '100%',
		},
	}),
);
